import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      fr: {
        translation: {
          language: {
            fr: 'Français',
            en: 'English',
          },
          requis: 'Requis',
          legal: {
            title: 'Avertissement',
            long1: "Estimation basée sur les informations disponibles et des hypothèses expliquées. Vous pouvez refuser l'augmentation de loyer dans le délai prévu.",
            long2: "Pour un désaccord, seul le Tribunal administratif du logement peut trancher.",
            long3: "Il s'agit d'une estimation et d'un outil pour vous aider dans vos négociations avec votre propriétaire et n'a aucune valeur légale."
          },
          buttons: {
              close: "Fermer",
              next: "Suivant",
              previous: "Précédent",
          },
          '2026': {
            breakdown: {
              title: 'Récapitulatif de l\'augmentation',
              ipc: 'IPC',
              municipalTax: 'Taxes municipales',
              schoolTax: 'Taxes scolaires',
              belowIPC: 'sous l\'IPC',
              subtotal: 'Sous-total',
            },
            summary: {
              unknown: '?',
              assumptions: 'Informations manquantes',
              insurance: 'Assurances (incendie et responsabilité)',
              insuranceUnknownNote: 'Assurances: le propriétaire pourrait avoir subi une augmentation des primes d\'assurance au-delà de l\'IPC, ce qui pourrait justifier un montant supplémentaire.',
            },
            step2: {
              prefilled: 'Données préremplies à partir des registres publics de Montréal. Vous pouvez les modifier si nécessaire.',
              prefilledWithAddress: 'Données préremplies à partir des registres publics de Montréal pour le compte de taxe associé à {{address}}. Vous pouvez modifier si nécessaire.'
            },
            insurance: {
              before: 'Assurances incendie et responsabilité annuelles au 31 décembre 2024',
              after: 'Assurances incendie et responsabilité annuelles au 31 décembre 2025'
            },
            step5: {
              question: 'Les assurances incendie et responsabilité du propriétaire ont-elles augmenté entre 2025 et 2026?'
            },
            ipcMinimumNotice: "Votre loyer peut \u00EAtre augment\u00E9 d'au moins {{amount}} par mois \u00E0 cause de l'IPC.",
            taxesMinimumNotice: "Votre loyer peut \u00EAtre augment\u00E9 d'au moins {{amount}} par mois \u00E0 cause des taxes.",
            insuranceMinimumNotice: "Votre loyer peut \u00EAtre augment\u00E9 d'au moins {{amount}} par mois \u00E0 cause des assurances.",
          },

          title: "Estimateur de hausse de loyer à Montréal",
          intro: {
            line1: "✱ Basé sur le calcul du <a href=\"https://www.tal.gouv.qc.ca/fr/calcul-pour-l-augmentation-de-loyer\" target=\"_blank\" rel=\"noreferrer\"><u>TAL 2026</u></a>",
            line2: "✱ Remplissage automatique d'informations",
            line3: "✱ Estimation seulement : certains logements suivent des règles particulières",
            line4: ""
          },
          calculator: {
            title1: 'Entrez vos informations',
            //title2: 'Calculer l\'augmentation de loyer raisonnable',
            rent: 'Quel est votre loyer mensuel actuel ?',
            rentInfo: 'Indiquez le montant de votre loyer mensuel (avant l’augmentation proposée par le propriétaire).',

            dwellings: 'Combien de logements se trouvent dans votre bâtiment?',
            dwellingsInfo: 'Combien de logements distincts (loués ou non) compte votre immeuble ? Par exemple, un duplex où aucun étage n’est subdivisé compte généralement 2 logements.',
            currency: ' $',
            heating: 'Comment est payé votre chauffage ?',
            heatingInfo: 'L\'outil d\'estimation d\'augmentation « raisonnable » du TAL prend en compte qui paie le chauffage de votre logement : vous ou votre propriétaire.Si c\'est le propriétaire qui paie, les différentes méthodes de chauffage entraînent des taux de pourcentage différents.',
            heatingType: {
              self: 'Je paie le chauffage moi-même',
              electricity: 'Mon propriétaire paie le chauffage électrique',
              gas: 'Mon propriétaire paie le chauffage au gaz',
              oil: 'Mon propriétaire paie le chauffage au mazout (ou autre)',
            },
            taxesTitle: 'Taxes municipales et scolaires',
            //municipalTax: 'Taxe municipale',
            municipalTaxThisYear: 'Taxes municipales pour l’année 2025',
            municipalTaxLastYear: 'Taxes municipales pour l’année 2024',

            schoolTaxThisYear: 'Taxe scolaire pour l’année 2024-2025',
            schoolTaxLastYear: 'Taxe scolaire pour l’année 2023-2024',

            ameliorations: 'Améliorations majeures, réparations ou autres travaux',
              ameliorationsBatiment: 'Montant dépensé pour les travaux majeurs sur l\'immeuble',
            ameliorationsBatimentInfo: 'Combien votre propriétaire a-t-il dépensé pour les réparations et les améliorations majeures de l\'immeuble dans son ensemble ?  Il peut s’agir de travaux visant à réparer ou modifier les principaux éléments de la structure de l’immeuble (toit, tuyauterie, système de chauffage, isolation, fenêtres), de travaux de rénovation dans les espaces communs.',
              ameliorationsLogement: 'Montant dépensé pour les travaux majeurs spécifiquement sur votre logement',
            ameliorationsLogementInfo: 'Combien votre propriétaire a-t-il dépensé spécifiquement pour des réparations majeures dans votre logement ? Il peut s\'agir de la rénovation d\'une salle de bain ou d\'une cuisine, du remplacement d\'armoires.',

            calculer: 'Calculer la hausse de loyer',
            questionAsterix: '* champ obligatoire',
          },
          modalTaxMunicipal: {
            button: "Comment trouver ces montants moi-même?",
            modalTexts: [
              'Pour connaître la modification de la taxe municipale pour votre immeuble, rendez-vous sur le site du <a target="_blank" rel="noopener noreferrer" href="https://montreal.ca/role-evaluation-fonciere">Rôle d\'évaluation foncière</a> de Montréal. Choisissez “Par adresse” et ensuite “Suivant.”',
              "Entrez votre adresse sur la page suivante. Cliquez “Rechercher.”",
              "Cliquez sur la flèche verte à droite de l'adresse qui correspond à la vôtre dans la liste.",
              "Allez  au bas de la page et cliquez sur “Compte de taxes” pour 2025 et 2024. Ces documents s'ouvriront en format PDF.",
              "Copiez le chiffre intitulé “total du compte”, en bas à droite du tableau de la première page. Une fois que vous l'avez trouvé dans les deux PDF, cliquez sur “Fermez” et entrez ces chiffres dans les champs de l'outil.<br/><br/>Entrez les chiffres pour l'ensemble du bâtiment, n'essayez pas de calculer la partie uniquement pour votre logement (l'outil le fera automatiquement).",
            ],
          },
          modalTaxScolaire: {
            button: "Comment trouver ces montants moi-même?",
            modalTexts: [
              'Pour connaître la modification de la taxe scolaire de l\'immeuble, rendez-vous sur le site du <a target="_blank" rel="noopener noreferrer" href="https://tfp.cgtsim.qc.ca/asp/TFP.aspx?jlsid=1&jlrun=tfpint.general.Accueil&site=int">Comité de gestion de la taxe scolaire</a>. Cliquez sur “Consulter les données”.',
              "Entrez votre adresse sur la page suivante.",
              "Cliquez sur l'icone de facture.",
              "Copiez les deux premiers chiffres de la colonne “Montant”, signifiant les montants des taxes scolaires pour les années 2024-2025 et 2023-2024. Ensuite cliquez sur “Fermez” et entrez ces chiffres dans les champs de l'outil. <br/><br/>Entrez les chiffres pour l'ensemble du bâtiment, n'essayez pas de calculer la partie uniquement pour votre logement (l'outil le fera automatiquement).",
            ],
          },

          explanation: {
            heating: "Ajustement de base lié au chauffage",
            municipalTax: "Ajustement lié aux changements de taxes municipales",
            schoolTax: "Ajustement lié aux changements de taxes scolaires",
            repairs: "Ajustement lié aux rénovations",
          },


          result: {
            rentIncreaseEstimate: 'Estimation d\'une augmentation juste et raisonnable de votre loyer',

                  rentIncreaseEstimateExplanation:
              'Comment nous avons déterminé l\'augmentation raisonnable?'
             },
          footer: {
            title: "Et maintenant?",
            disclaimer1:
              "",
            disclaimer2: "",
            disclaimer3:
              "",
            disclaimerLink:
              "https://www.tal.gouv.qc.ca/fr/calcul-pour-l-augmentation-de-loyer",
            disclaimerLinkTitle:
              "",
            line1: "Vous avez le droit de refuser une augmentation de loyer.",
            line2:
              "Le Tribunal administratif du logement offre un formulaire intitulé",
            link1:
              "https://www.tal.gouv.qc.ca/sites/default/files/notices/TAL_810_E.pdf",
            linkTitle1:
              "Réponse du locataire à l’avis d’augmentation de loyer et de modification d’une autre condition du bail",
            line3:
              ", que vous pourrez imprimer et livrer à votre propriétaire par courrier recommandé. Souvenez-vous :",
            line4:
              "vous devez répondre dans le mois suivant la réception de l'avis d'augmentation.",
            line5: "Si vous avez besoin d'aide,",
            line5a: "contactez votre comité du logement local",
            line5b: ". Cliquez",
            link2: "https://rclalq.qc.ca/comites-logement/",
            linkTitle2: "ici",
            line6: "pour trouver celui qui est le plus proche de chez vous.",
            line7:
              "Pour le calcul complet, utilisez ",
            link3: "https://www.tal.gouv.qc.ca/fr/calcul-pour-l-augmentation-de-loyer",
            linkTitle3: "l'outil de calcul 2026 du TAL.",
            line8: "Vous pouvez aussi imprimer cette page dans une bibliothèque de la Ville de Montréal pour 0,10 $ par page, puis vous rendre dans un bureau de poste pour demander l'envoi par courrier recommandé à votre propriétaire.",
            link4: "https://montreal.ca/lieux?mtl_content.lieux.installation.code=BIBL&orderBy=dc_title&listType=map",
            linkTitle4: "Trouver une bibliothèque de la Ville de Montréal",
          },
          share: {
            title: 'Partager ce calcul',
            name: 'Votre prénom (optionnel)',
            phone: 'Votre numéro de cell (pour recevoir le lien)',
            explain: 'Nous envoyons un lien avec ce résumé (sans adresse) pour le partager facilement.',
            cta: 'Copier le lien de partage',
            copied: 'Lien de partage copié dans le presse-papier',
          },
          sharedResult: {
            header: 'Estimation partagée',
            details: 'Détail partagé',
            notes: 'Notes',
            prorata: 'Répartition estimée',
            insuranceMissing: 'Assurances inconnues (montant à confirmer).',
            unknown: '?',
          },
          author: {
            line2: "Développé par Nicolas Jolicoeur, conseiller d'arrondissement du Sud-Ouest",

          },
          address: {
            borough: "Arrondissement",
            selectBorough: "Choisir un arrondissement",
            streetNumber: "Numéro civique",
            streetNumberHint: "Chiffres seulement (ex.: 150A → 150)",
            streetName: "Nom de la rue",
            appNumber: "Appartement (optionnel)"
          },
          loading: "Chargement...",
          addressSearch: {
            selectBorough: "Choisissez votre arrondissement",
            title: "Recherche d'adresse à Montréal",
            description: "Entrez votre adresse pour que nous puissions récupérer les informations disponibles pour votre immeuble.",
            streetNumber: "Numéro civique",
            streetNumberHint: "Chiffres seulement (ex.: 150A → 150)",
            streetName: "Nom de la rue",
            appNumber: "Numéro d'appartement (optionnel)",
            search: "Rechercher",
            searching: "Recherche en cours...",
            results: "Résultats",
            taxAmount: "Montant de la taxe",
            taxAmountYear: "Montant de la taxe pour",
            schoolTaxAmount: "Montant de la taxe scolaire",
            schoolTaxAmountYear: "Montant de la taxe scolaire pour",
            requiredFields: "Le numéro civique et le nom de la rue sont requis",
            noResults: "Aucun résultat trouvé pour cette adresse",
            genericError: "Une erreur s'est produite lors de la recherche. Veuillez réessayer.",
            selectBoroughRequired: "Veuillez sélectionner un arrondissement",
            multipleAccounts: "Plus qu'un compte de taxes à l'adresse. Veuillez entrer un numéro d'appartement",
            buildingPermits: "Permis de construction récents",
            permitsFound: "{{count}} permis trouvés",
            noPermitsFound: "Aucun permis de construction récent trouvé pour cette adresse",
            startDate: "Date de début",
            location: "Emplacement",
            borough: "Arrondissement",
            workType: "Nature des travaux",
            addressFound: "Informations trouvées pour le bâtiment contenant l'adresse",
            apply: "Utiliser"
          },

          permitSearch: {
            title: 'Recherche de permis de travaux à Montréal',
            subtext: 'Le propriétaire doit généralement demander un permis à la Ville pour effectuer légalement des travaux majeurs.',
            button: 'Rechercher des permis de travaux',
            noResult: 'Aucun permis récent (2023-2024) trouvé pour l\'adresse indiquée plus haut dans la page. Si le propriétaire affirme que des travaux ont été effectués, vous pouvez lui demander si un permis était nécessaire.',
           // emplacement: 'Emplacement',
            //dateDebut: 'Date de début',
           // natureTravaux: 'Nature des travaux'

          }



          
         
        },

      },







      en: {
        translation: {
          language: {
            fr: 'Français',
            en: 'English',
          },
          requis: 'Required',
          legal: {
            title: 'Warning',
            long1: 'Estimate based on available information and stated assumptions.',
            long2: 'In case of disagreement, only the Tribunal administratif du logement can decide.',
            long3: 'This is an estimate and a tool to help you negotiate with your landlord and has no legal value.'
          },
            buttons: {
                close: "Close",
                next: "Next",
                previous: "Previous",
            },
            '2026': {
              breakdown: {
                title: 'Increase Summary',
                ipc: 'CPI',
                municipalTax: 'Municipal taxes',
                schoolTax: 'School taxes',
                belowIPC: 'below CPI',
                subtotal: 'Subtotal',
              },
              summary: {
                unknown: '?',
                assumptions: 'Missing Information',
                insurance: 'Insurance (fire and liability)',
                insuranceUnknownNote: 'Insurance: the landlord may have experienced an increase in insurance premiums above CPI, which could justify an additional amount.',
              },
              step2: {
                prefilled: 'Pre-filled data from Montreal public records. You can edit if needed.',
                prefilledWithAddress: 'Pre-filled data from Montreal public records for the tax account linked to {{address}}. You can edit if needed.'
              },
              insurance: {
                before: 'Monthly fire and liability insurance before',
                after: 'Monthly fire and liability insurance now'
              },
              step5: {
                question: 'Have the landlord’s fire and liability insurance increased by more than {{ipcLabel}}?'
              },
              ipcMinimumNotice: "Your rent could increase by at least {{amount}} per month because of CPI.",
              taxesMinimumNotice: "Your rent could increase by at least {{amount}} per month because of taxes.",
              insuranceMinimumNotice: "Your rent could increase by at least {{amount}} per month because of insurance.",
            },
            title: 'Reasonable Rent Increase Estimator',
            intro: {
              line1: "✱ Based on the <a href=\"https://www.tal.gouv.qc.ca/sites/all/themes/rdl/assets/img/Modifications-reglementaires.pdf\" target=\"_blank\" rel=\"noreferrer\"><u>TAL 2026</u></a>",
              link: "https://www.tal.gouv.qc.ca/fr/reconduction-du-bail-et-fixation-de-loyer/augmentation-de-loyer",
              linkTitle: "new TAL 2026 calculation",
              line2: "✱ <u>Auto-fills</u> several items using City of Montréal open data",
              line3: "✱ <u>Estimate only</u>: some items come from the landlord and some dwellings (new builds, seniors’ residences) follow special rules"
            },

            calculator: {
              title1: 'Enter your information',
              //title2: 'Calculate reasonable rent increase',
              //currentRent: 'Current rent',
              //currency: ' $',
              rent: 'What is your current monthly rent?',
              rentInfo: 'Enter the amount of your monthly rent (before the increase proposed by the landlord).',

              dwellings: 'How many dwellings are in your building?',
              dwellingsInfo: 'How many separate dwellings (rented or not) are in your building? For example, a duplex where no floors are subdivided usually has 2 units.',
              currency: ' $',

             heating: 'How is your heating paid?',
            heatingInfo: "The TAL's \"reasonable\" increase calculator factors in whether your or your landlord pay for the heating in your dwelling. If they pay for it, different heating methods carry different percentage rates.",
              heatingType: {
                self: 'I pay for heating myself',
                electricity: "My landlord pays for electric heating",
                gas: "My landlord pays for gas heating",
                oil: "My landlord pays for oil (or other) heating"
              },
            taxesTitle: 'Municipal and school taxes for the building',
            // municipalTax: 'Municipal tax',
            municipalTaxThisYear: 'Municipal tax for 2025',
            municipalTaxLastYear: 'Municipal tax for 2024',

            schoolTaxThisYear: 'School tax for 2024-2025',
              schoolTaxLastYear: 'School tax for 2023-2024',

              ameliorations: 'Major improvements, repairs or other work',
                ameliorationsBatiment: 'Amount spent on major repairs for the whole building',
              ameliorationsBatimentInfo: 'How much did your landlord spend on major repairs and improvements of the building as a whole? This may involve work aimed at repairing or modifying the main elements of the building\'s structure (roof, pipes, heating system, insulation, windows), renovations in common areas.',
                ameliorationsLogement: 'Amount spent on major repairs for your dwelling specifically',
              ameliorationsLogementInfo: 'How much did your landlord spend on major repairs in your dwelling specifically? This may involve work aimed at renovating a bathroom or a kitchen, replacement of cabinets.',

              calculer: 'Calculate rent increase',
              questionAsterix: '* required field',
            },

             municipalTaxModal: {
              button: "How do I find these amounts?",

              modalTexts: [
                'In order to verify how the municipal taxes have changed for your building, go to the website of <a target="_blank" href="https://montreal.ca/role-evaluation-fonciere">Rôle d\'évaluation foncière</a>. Pick “Par adresse” and then “Suivant”.',
                "On the following page enter your address. The website is not available in English, but you can translate it using Google Translate. Click “Rechercher”.",
                "Click on the green arrow to the right of the address that matches yours in the list.",
                "Go to the bottom of the page and click on “Compte de taxes” for both 2025 and 2024. These will open PDF documents.",
                "Copy the number labelled “Total du compte” in the bottom right of the table on the first page. Once you've found it in both PDFs, click “Close” and enter those numbers in the fields of the calculator.<br/><br/>Enter the numbers for the whole building. Do not try to calculate the part just for your dwelling (the tool will do that automatically).",
              ],
            },
          schoolTaxModal: {
            button: "How do I find these amounts?",

            modalTexts: [
              'In order to verify how the school taxes have changed for your building, go to the website of  <a target="_blank" rel="noopener noreferrer" href="https://tfp.cgtsim.qc.ca/asp/TFP.aspx?jlsid=1&jlrun=tfpint.general.Accueil&site=int">Comité de gestion de la taxe scolaire</a>. Click on “View data”.',
              "Enter your address on the following page.",
              "Click on the bill icon.",
              "Copy the first two numbers from the “Amount” column, which are the school tax amounts for the years 2023-2024 and 2022-2023. Then click “Close” and enter those numbers in the fields of the calculator.<br/><br/>Enter the numbers for the whole building. Do not try to calculate the part just for your dwelling (the tool will do that automatically).",
            ],
          },
          explanation: {
            heating: "Base adjustement related to heating",
            municipalTax: "Adjustment related to municipal tax changes",
            schoolTax: "Adjustment related to school tax changes",
            repairs: "Adjustment related to repairs",
          },

          result: {
            rentIncreaseEstimate: 'Reasonable increase estimation',
            rentIncreaseEstimateExplanation: 'How we determined the reasonable increase?'
             },

          footer: {
            title: "What's next?",
            disclaimer1:
              "",
            disclaimer2: "",
            disclaimer3:
              "",
            disclaimerLink:
              "https://www.tal.gouv.qc.ca/fr/calcul-pour-l-augmentation-de-loyer",
            disclaimerLinkTitle:
              "",
            line1: "You have the right to refuse a rent increase. ",
            line2: "Tribunal administratif du logement offers a form titled",
            link1:
              "https://www.tal.gouv.qc.ca/sites/default/files/notices/TAL_810A_E.pdf",
            linkTitle1:
              "Lessee’s response to a notice of rent increase and modification of another condition of the lease",
            line3:
              ", which you can print and deliver to your landlord by registered mail. Remember:",
            line4:
              "you must reply within one month of receiving the notice of increase.",
            line5: "If you need help,",
            line5a: "contact your local housing committee",
            line5b: ". Click",
            link2: "https://rclalq.qc.ca/en/housing-committee/",
            linkTitle2: "here",
            line6: "to find the one that is the closest to you.",
          //  line7: "This tool is based on 2025's estimation sheet created by",
           // line8: "You can download this estimation sheet as a ",
           // line9: "or",
           // line10: "file.",
            
            link3: "https://www.tal.gouv.qc.ca/fr/calcul-pour-l-augmentation-de-loyer",
            linkTitle3: "the TAL rent increase calculation page.",
            line8: "You can also print this page at a City of Montreal library for $0.10 per page, then go to a post office and ask to send it to your landlord by registered mail.",
            link4: "https://montreal.ca/lieux?mtl_content.lieux.installation.code=BIBL&orderBy=dc_title&listType=map",
            linkTitle4: "Find a City of Montreal library",
          },

          author: {
            line1: "Developed by Nicolas Jolicoeur",
            line2: "Source code of Krystyna Szurmanska's project.",
            },
            share: {
              title: 'Share this calculation',
              name: 'Your first name (optional)',
              phone: 'Your mobile number (to receive the link)',
              explain: 'We send a link with this summary (no address) so you can share it easily.',
              cta: 'Copy sharing link',
              copied: 'Sharing link copied to clipboard',
            },
            sharedResult: {
              header: 'Shared estimate',
              details: 'Shared breakdown',
              notes: 'Notes',
              prorata: 'Estimated share',
              insuranceMissing: 'Insurance unknown (amount to confirm).',
              unknown: '?',
            },
            about: {
              title: 'À propos',
              subtitle: 'Un outil développé par Nicolas Jolicoeur, conseiller d’arrondissement (Le Sud-Ouest, Montréal)',
              insta: 'Instagram',
              facebook: 'Facebook',
              tiktok: 'TikTok',
            },
            address: {
              borough: "Borough",
              selectBorough: "Select a borough",
            streetNumber: "Street number",
            streetNumberHint: "Digits only (e.g., 150A → 150)",
            streetName: "Street name",
            appNumber: "Apartment (optional)"
          },
          loading: "Loading...",
            addressSearch: {
              selectBorough: "Select your borough",
              title: "Address Search in Montréal",
              description: "Enter your address so we can retrieve available information for your building.",
              streetNumber: "Street number",
              streetNumberHint: "Digits only (e.g., 150A → 150)",
              streetName: "Street name",
              appNumber: "Apartment number (optional)",
            search: "Search",
            searching: "Searching...",
            results: "Results",
            taxAmount: "Tax amount",
            taxAmountYear: "Tax amount for",
            schoolTaxAmount: "School tax amount",
            schoolTaxAmountYear: "School tax amount for",
            requiredFields: "Street number and street name are required",
            noResults: "No results found for this address",
            genericError: "An error occurred while searching. Please try again.",
            selectBoroughRequired: "Please select a borough",
            multipleAccounts: "More than one tax account. Please enter an apartment number",
            buildingPermits: "Recent Building Permits",
            permitsFound: "{{count}} permits found",
            noPermitsFound: "No recent building permits found for this address",
            startDate: "Start Date",
            location: "Location",
            borough: "Borough",
            workType: "Type of Work",
            addressFound: "Information found for the building containing the address",
            apply: "Select",

          },

          permitSearch: {
              title: 'Work Permit Search in Montréal',
              subtext: 'The landlord must generally obtain a permit from the City to legally carry out major work.',
              button: 'Search for Work Permits',
              noResult: 'No recent permits (2023-2024) found for the address indicated earlier on the page. If the landlord claims that work has been done, you can ask them if a permit was required.',
              location: 'Location',
              startDate: 'Start Date',
              workType: 'Type of Work'
          }

          

        



          
        },
      },
    },
  });

export default i18n;
